//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['data', 'selectedItems'],
  methods: {
    toggleItem: function toggleItem(event, itemId) {
      this.$emit('toggle-item', event, itemId);
    }
  }
};